import "../../Stylesheets/CustomButtonsStyles.css";

interface CustomLoaderProps {
  loadingTitle?: string;
}

const CustomLoader = (props: CustomLoaderProps) => {
  return (
    <div className="LoadingContainerMain">
      <div className="LoadingContainer">
        <h4 className="LoadingText">{props.loadingTitle}</h4>
        <div className="dots">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default CustomLoader;
